var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5443 5.33203H18.0522L17.5772 6.99893H20.3359V16.1669H3.6669V6.99893H5.67551L5.40881 5.94045C5.3588 5.74042 5.3338 5.54039 5.3338 5.33203H3.45854C2.65843 5.33203 2 5.99046 2 6.79057V18.0421C2 18.8423 2.65843 19.5007 3.45854 19.5007H9.8411C9.74275 19.9182 9.48355 20.5958 8.78928 21.2893C8.6701 21.4084 8.63426 21.5876 8.69927 21.7435C8.76345 21.8994 8.91597 22.001 9.08433 22.001H14.9185C15.0868 22.001 15.2394 21.8994 15.3035 21.7435C15.3677 21.5876 15.3319 21.4084 15.2135 21.2893C14.5209 20.5967 14.2542 19.9191 14.1509 19.5007H20.5443C21.3444 19.5007 22.0028 18.8423 22.0028 18.0421V6.79057C22.0028 5.99046 21.3444 5.33203 20.5443 5.33203Z",
    fill: "#FF8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5011 9.50173H8.66696C8.2844 9.50173 7.95102 9.24169 7.85851 8.87081L7.02506 5.53701C6.96255 5.2878 7.01839 5.0236 7.17675 4.82191C7.3351 4.62021 7.5768 4.50103 7.83351 4.50103H14.8253L15.3671 2.60493C15.4937 2.16237 15.9555 1.90566 16.3972 2.03235C16.8398 2.15903 17.0956 2.61993 16.9698 3.06249L15.3029 8.89664C15.2004 9.25503 14.8728 9.50173 14.5011 9.50173Z",
    fill: "#FF8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 12.0009C10.7938 12.0009 11.1669 11.6277 11.1669 11.1674C11.1669 10.7071 10.7938 10.334 10.3335 10.334C9.87315 10.334 9.5 10.7071 9.5 11.1674C9.5 11.6277 9.87315 12.0009 10.3335 12.0009Z",
    fill: "#FF8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6674 12.0009C14.1277 12.0009 14.5009 11.6277 14.5009 11.1674C14.5009 10.7071 14.1277 10.334 13.6674 10.334C13.2071 10.334 12.834 10.7071 12.834 11.1674C12.834 11.6277 13.2071 12.0009 13.6674 12.0009Z",
    fill: "#FF8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.ac96ed1ca93b8d24a0e2c6f6c7f26caa.svg";
export { ForwardRef as ReactComponent };